import { NodeData } from "@/pages/Private/pages/List/components/CampaignOverview/pages/CampaignPage";
import { replacePlaceholders } from "@/pages/Private/pages/List/components/CampaignOverview/utils/replacePlaceholders";
import { ListPerson } from "@/pages/Private/pages/List/schema/list";

/**
 * Body shown for an already-sent step: prefer the conversation content captured
 * at send time (variables resolved by the backend), otherwise fall back to the
 * step template. Either way, any remaining placeholders are replaced from the
 * lead's data so the user never sees raw `{var|Label}` tokens.
 */
export const resolveSentStepMessage = (
	data: NodeData,
	eventBasedState: boolean,
	lead: ListPerson,
	suggestions: string[]
): string =>
	replacePlaceholders(
		data.sentMessage ?? (eventBasedState ? (data.alternateMessage ?? "") : (data.message ?? "")),
		lead,
		suggestions
	);

/**
 * Subject shown for an already-sent step — same resolution order as
 * {@link resolveSentStepMessage}.
 */
export const resolveSentStepSubject = (
	data: NodeData,
	eventBasedState: boolean,
	lead: ListPerson,
	suggestions: string[]
): string =>
	replacePlaceholders(
		data.sentSubject ?? (eventBasedState ? (data.alternateSubject ?? "") : (data.subject ?? "")),
		lead,
		suggestions
	);
